import * as React from 'react';
import { Autocomplete } from '@material-ui/lab';
import { FormLabel, TextField, makeStyles, Paper } from '@material-ui/core';

import { useCompanies } from 'entities/organization/useCompanies';
import Organization from 'entities/organization/model';

export const useStyles = makeStyles(() => ({
  inputRoot: {
    minHeight: 45,
  },
}));

export const CompanySelectInput = ({
  values = [],
  onChange,
}: {
  values: string[];
  onChange: (companyIds: string[]) => void;
}): JSX.Element => {
  const classes = useStyles();
  const { data: companies, loading, error } = useCompanies();
  const options = companies.map((company) => {
    const { id, name } = new Organization(company);
    return {
      id,
      name,
    };
  });

  if (error) {
    return (
      <FormLabel error>
        An error occurred while trying to load companies data, please try again.
      </FormLabel>
    );
  }
  return (
    <Autocomplete
      classes={classes}
      multiple
      loading={loading}
      loadingText="Loading…"
      filterOptions={(opts, { getOptionLabel, inputValue }) =>
        opts.filter((o) =>
          getOptionLabel(o).toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())
        )
      }
      value={options.filter((i) => values.includes(i.id))}
      PaperComponent={(paperProps) => <Paper {...paperProps} square />}
      options={options}
      getOptionLabel={(option) => option.name}
      renderInput={(params) => (
        <TextField {...params} variant="standard" label="Search companies by name" placeholder="" />
      )}
      onChange={(_event, value) => {
        onChange(value.map((i) => i.id));
      }}
    />
  );
};
